export default __webpack_public_path__ + "static/repairInterior-f62229a71983e637a9bd1003913c244f.jpg";